import React from 'react'
import PropTypes from 'prop-types'

import { Box, Flex } from '@chatterbug/aaron'
const AVATAR_SIZE = {
  small: '72px',
  large: '88px',
}
const TutorAvatarSkeleton = ({ avatarSection, size = 'large' }) => {
  return (
    <Flex justifyContent="center">
      <Box
        width={{ _: AVATAR_SIZE.small, tablet: AVATAR_SIZE[size] }}
        height={{ _: AVATAR_SIZE.small, tablet: AVATAR_SIZE[size] }}
        textAlign="center"
      >
        {avatarSection}
      </Box>
    </Flex>
  )
}

TutorAvatarSkeleton.propTypes = {
  avatarSection: PropTypes.any,
  size: PropTypes.oneOf(['large', 'small']),
}

export default TutorAvatarSkeleton
